import { MATERIAL_CATEGORIES } from "..";

const MaterialFormSection = ({ ctx }) => {
  const {
    closeDialog,
    editingMaterial,
    handleMaterialSubmit,
    materialForm,
    setMaterialForm
  } = ctx;
  return (
    <>
            <form onSubmit={handleMaterialSubmit} className="space-y-4 mt-4">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Material Name</label>
                <input
                  type="text"
                  data-testid="material-name-input"
                  required
                  value={materialForm.name}
                  onChange={(e) => setMaterialForm({ ...materialForm, name: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="Cement, Aggregate, Bitumen"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Category</label>
                <select
                  data-testid="material-category-select"
                  value={materialForm.category}
                  onChange={(e) => setMaterialForm({ ...materialForm, category: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  {MATERIAL_CATEGORIES.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.label}</option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Unit</label>
                  <select
                    data-testid="material-unit-select"
                    value={materialForm.unit}
                    onChange={(e) => setMaterialForm({ ...materialForm, unit: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    <option value="MT">MT</option>
                    <option value="Bags">Bags</option>
                    <option value="Cum">Cum</option>
                    <option value="Liters">Liters</option>
                    <option value="Nos">Nos</option>
                    <option value="Kg">Kg</option>
                    <option value="Pcs">Pcs</option>
                    <option value="Set">Set</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Opening Stock</label>
                  <input
                    type="number"
                    step="0.01"
                    data-testid="material-stock-input"
                    required
                    value={materialForm.opening_stock}
                    onChange={(e) => setMaterialForm({ ...materialForm, opening_stock: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Rate (₹)</label>
                  <input
                    type="number"
                    step="0.01"
                    data-testid="material-rate-input"
                    required
                    value={materialForm.rate}
                    onChange={(e) => setMaterialForm({ ...materialForm, rate: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Minimum Stock (Alert)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={materialForm.minimum_stock}
                    onChange={(e) => setMaterialForm({ ...materialForm, minimum_stock: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                    placeholder="0"
                  />
                </div>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button type="button" onClick={closeDialog} className="btn-outline">Cancel</button>
                <button type="submit" data-testid="submit-material-button" className="btn-primary">
                  {editingMaterial ? 'Update Material' : 'Add Material'}
                </button>
              </div>
            </form>
    </>
  );
};

export default MaterialFormSection;
